import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import SurveyEditor from './components/Survey/SurveyEditor';
import { UserEditor } from './components/User/UserEditor';
import HomePage from './views/Home';
import SurveysPage from './views/Surveys';
import UsersPage from './views/Users';
import SectionsPage from './views/Sections';
import SettingsPage from './views/Settings';
import SurveyDetails from './components/Survey/SurveyDetails';
import NotFoundPage from './views/NotFound';
import SurveyForm from './components/Survey/Response/SurveyForm';
import { useSelector } from 'react-redux';
import { selectNavigation } from './store/slices/User/selectors';
import UserActivity from './components/User/UserActivity';

const AppRoutes: FC = () => {
  const navigation = useSelector(selectNavigation);
  const navigationPaths = navigation.map(nav => nav.path);
  const routes = [{
    path: '/',
    component: HomePage,
  }, {
    path: '/encuestas',
    component: SurveysPage,
  }, {
    path: '/encuestas/crear',
    component: SurveyEditor,
  }, {
    path: '/encuestas/:id',
    component: SurveyDetails,
  }, {
    path: '/encuestas/:id/editar',
    component: SurveyEditor,
  }, {
    path: '/encuestas/:id/aplicar',
    component: SurveyForm,
  }, {
    path: '/colaboradores',
    component: UsersPage,
  }, {
    path: '/colaboradores/nuevo',
    component: UserEditor,
  }, {
    path: '/colaboradores/:id',
    component: UserActivity,
  }, {
    path: '/colaboradores/:id/editar',
    component: UserEditor,
  }, {
    path: '/secciones',
    component: SectionsPage,
  }, {
    path: '/ajustes',
    component: SettingsPage,
  }, {
    path: '*',
    component: NotFoundPage,
  }];

  const paths = routes.filter(route => navigationPaths.includes(route.path));
  return (
    <>
      <Routes>
        {paths.map((route, index) => (
          <Route key={index} path={route.path} Component={route.component} />
        ))}
      </Routes>
    </>
  )
};

export default AppRoutes;
